/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Click_Link_SignupInputs */



/**
* | output |
* | --- |
* | "Click the link to set your password and complete signup." |
*
* @param {Login_Click_Link_SignupInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_click_link_signup = /** @type {((inputs?: Login_Click_Link_SignupInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Click_Link_SignupInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cliquez sur le lien pour définir votre mot de passe et finaliser l'inscription.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Haga clic en el enlace para establecer su contraseña y completar el registro.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Clique no link para definir sua senha e completar o cadastro.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Clicca sul link per impostare la tua password e completare la registrazione.")
	return /** @type {LocalizedString} */ ("Click the link to set your password and complete signup.")
});